import React, { useCallback, useContext, useMemo } from 'react'
import { ReportingContext } from '../../../../wrappers/ReportingContext'
import { Controller, useFormContext } from 'react-hook-form'
import CollapsibleContainer from '../CollapsibleContainer'
import InputField, { InputFieldSimple } from './InputField'
import CreatableSelect from 'react-select/creatable'
import ReportSelect, { selectStyles } from '../../../select/ReportSelect'
import { validateUniqueReportName } from '../../../../../utils/reporting/config'

const ReportInformation = () => {
    const {
        reportSelectOptions,
        reports,
        report,
        viewOnly,
        reportConfig
    } = useContext(ReportingContext)
    
    const { register, control, } = useFormContext()

    const databaseOptions = useMemo(() => {
        return reportSelectOptions?.databases || []
    }, [reportSelectOptions])

    const dataSourceOptions = useMemo(() => {
        return reportSelectOptions?.dataSources || []
    }, [reportSelectOptions])

    const tagOptions = useMemo(() => {
        return reportSelectOptions?.tags || []
    }, [reportSelectOptions])

    var dataSourceOptionsFormatted = useMemo(() => dataSourceOptions.map(ds => ({label: ds.label, value: ds.value })), [dataSourceOptions])

    const reportNameProps = {
        className: "input is-normal",
        name: "reportName",
        disabled: viewOnly,
        placeholder: 'Enter a unique report name',
        ref: register({
            required: 'Required field',
            validate: value => validateUniqueReportName(value, reports, report),
        }),
    }

    return (
        <CollapsibleContainer title="Report Information">
            <InputFieldSimple
                label={
                    <span>
                        Report Name{' '}
                        <span className='has-text-danger'>*</span>
                    </span>
                }
                name="reportName"
                inputProps={{...reportNameProps}}
            />
            
            <InputField
                label={
                    <span>
                        Report Description <span className="has-text-danger">*</span>
                    </span>
                }
                name='reportDescription'
                helpText="Required description for your report"
            >
                <textarea
                    className='textarea is-normal'
                    name='reportDescription'
                    disabled={viewOnly}
                    placeholder="Describe your report"
                    ref={register({
                        required: 'Required field'
                    })}
                />
            </InputField>
            
            <InputField
                label="Database Name"
                name="databaseName"
                hidden="true"
            >
                <ReportSelect
                    name={"databaseName"}
                    control={control}
                    options={databaseOptions}
                    disabled={viewOnly}
                    value={reportConfig.databaseName}
                />
            </InputField>
            <InputField
                label="Primary Data Source Name"
                name="primaryDataSourceName"
                hidden="true"
            >
                <ReportSelect
                    name={"primaryDataSourceName"}
                    control={control}
                    options={dataSourceOptionsFormatted}
                    disabled={viewOnly}
                    value={reportConfig.primaryDataSourceName}
                />
            </InputField>
            <InputField label="Tags" name="tags">
                <Controller
                    as={
                        <CreatableSelect
                            isMulti
                            styles={selectStyles}
                            options={tagOptions}
                            isDisabled={viewOnly}
                        />
                    }
                    onChange={([value]) => {
                        return value
                    }}
                    name="tags"
                    control={control}
                />
            </InputField>
        </CollapsibleContainer>
    )
}

export default ReportInformation
